import DeviceList from './DeviceList';

export default DeviceList;



// WEBPACK FOOTER //
// ./src/components/DeviceList/index.js